module.exports = __webpack_public_path__ + "static/img/gray1.f74802c0.png";